import React, { useState } from 'react'
import { transactionTimeStamp } from '../../utils'
import ArrowIcon from './icons/ArrowIcon'
import ModalDialog from '../layouts/ModalDialog'

const FeedbackCard = ({item}) => {

    const [readingFeedback, setReadingFeedback] = useState(false)

    const openFeedback = () => {
        setReadingFeedback(true)
    }

    const closeFeedback = () => {
        setReadingFeedback(false)
    }


    return (
        <>
            <div className='flex items-center justify-between w-full py-3 rounded p-4'>
                <div className='flex items-start gap-x-3'>
                    <div className='w-[60px]'>
                        <div className='w-[50px] h-[50px] rounded-full bg-gray-200' style={{
                            backgroundImage: `url(" ${item.createdBy.avatar} ")`,
                            backgroundSize: 'cover',
                            backgroundPosition: 'center center',
                            backgroundRepeat: 'none'
                        }}>
                        </div>
                    </div>
                    <div className='w-full'>
                        <div className='w-full flex items-center justify-between mb-2'>
                            <p className='text-sm text-gray-500'>{item.createdBy.fullName}</p>
                            <p className='text-sm text-gray-400'>{transactionTimeStamp(item.createdAt).date}</p>
                        </div>
                        <p className='text-ellipsis overflow-hidden text-sm text-gray-600'>{item.excerpt}</p>
                        <button onClick={()=>{openFeedback(item)}} className='flex items-center justify-center gap-x-[5px] text-sm font-space-grotesk font-[500]'>Read more <ArrowIcon className={`w-3 h-3`} />  </button>
                    </div>
                </div>
                
            </div>

            <ModalDialog
                shown={readingFeedback} 
                closeFunction={()=>{closeFeedback()}} 
                actionFunction={()=>{}} 
                actionFunctionLabel={``}
                dialogTitle={`feedback details`}
                maxWidthClass='max-w-2xl'
                hideActions={true}
            >
                <div className='p-[20px]'>
                <div dangerouslySetInnerHTML={{__html: item.feedback}} />
                </div>
            </ModalDialog>
        </>
    )
}

export default FeedbackCard